<template>
    <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
        <b-form @submit.prevent="handleSubmit(salvar)">
            <h6 class="mb-3 text-left">
                Edite e salve os dados da Programação
                <b-button class="float-right m-1" size="sm" type="submit">
                    <font-awesome-icon icon="save" />
                    Salvar
                </b-button>
            </h6>
            <b-row class="w-100">
                <b-col cols="12" md="5">
                    <default-form-validation-provider label="Nome do Evento" rules="required|max:120"
                        v-slot="defState">
                        <b-form-input v-model="programacao.NmEvento" :state="defState.state"></b-form-input>
                    </default-form-validation-provider>
                </b-col>
                <b-col cols="12" md="6">
                    <default-form-validation-provider label="Tipo do Evento" v-slot="defaultState">
                        <b-form-select id="select-tipo" v-model="programacao.IdTipoEvento" :options="listaTipoEvento"
                            :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                </b-col>
            </b-row>
        </b-form>
    </validation-observer>
</template>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import { ValidationObserver } from "vee-validate"
import { DatePickerDefaultProps, FormGroupDefaultCols } from '@/types/form-default-props'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import programacaoService from '@/services/eventos/programacaoService'
import eventoService from '@/services/licitacoes/eventosService'
import { Programacao } from '@/types/eventos/programacao/programacao'
import { SelectValue } from '@/types/select-value'

const CompProps = Vue.extend({
    name: 'AbaEditarDadosProgramacao',
    components: { 
                  DefaultFormValidationProvider, ValidationObserver, 
                },
    props: {
        prog: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class AbaEditarDadosProgramacao extends mixins(UtilsTS, CompProps) {
    @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
    datePickerProps = DatePickerDefaultProps
    formGroupCols = FormGroupDefaultCols
    valorPadraoSelect: SelectValue = { value: null, text: 'SELECIONE UMA OPÇÃO', disabled: true }
    listaTipoEvento: SelectValue[] = [this.valorPadraoSelect]
    programacao: Programacao = new Programacao()

    /** Validar e salvar dados iniciais de novo contrato */
    async salvar(): Promise<void> {
        store.blockScreen = true
        try {
            const isValid = await this.validationobserver.validate();
            if (!isValid) {
                console.error(this.validationobserver)
            } else {
                //salvar a programacao 
                const retorno = await programacaoService.salvarProgramacao(this.programacao)
                this.$emit('atualizarProgramacao', retorno)
                this.$toast.success(`Os dados da programação foram salvos!`)
                this.programacao = retorno
                this.programacao.tratarDadosDaAPI()
            }
        } catch (e: any) {
            this.tratarError(e, true)
        } finally {
            store.blockScreen = false
        }
    }

    async montarCombos(): Promise<void> {
        const response = await eventoService.listarTiposEvento()
        this.listaTipoEvento.push(...response.data
            .map(t => {
                return { value: t.IdTipoEvento, text: t.DeTipoEvento }
            }))
    }
    async mounted() {
        try {
            if (this.prog.IdProgramacao > 0) {
                this.programacao = this.prog
                this.programacao.tratarDadosDaAPI()
            }
            store.blockScreen = true
            await this.montarCombos()
        } catch (e: any) {
            console.error('Problema ao montar o componente EditarDadosProgramacao', e)
        } finally {
            store.blockScreen = false
        }
    }
}


</script>

<style></style>